<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="心悦公会"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="aform">
        <el-form-item label="logo" required>
            <avatar-uploader
              @getImgUrl="(v)=> form.logo = v"
              :url="form.logo"
            ></avatar-uploader>
          </el-form-item>
        <el-form-item label="公会名称" required prop="name">
          <el-input v-model="form.name" placeholder="公会名称"></el-input>
        </el-form-item>
        <el-form-item label="负责人" required prop="leader_name">
          <el-input v-model="form.leader_name" placeholder="负责人"></el-input>
        </el-form-item>
        <el-form-item label="电话" required prop="leader_phone">
          <el-input :disabled="temp.id" v-model="form.leader_phone" placeholder="电话"></el-input>
        </el-form-item>
        <div>
          负责人使用这个电话登录账号进行公会管理
        </div>
        <el-form-item label="省市区">
          <city-select @change="changeCity" :temp="cityList"></city-select>
        </el-form-item>
        <el-form-item label="合作类目" required >
          <el-select
            v-model="change_categories"
            multiple
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in categories"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      if_clear: true,
      cityList:[],
       change_categories: [],
      categories: "",
    };
  },
  mounted() {
    this.getCategories();
  },

  methods: {
     getCategories() {
      this.$get("user/mechanismCategory/queryListPageChild", {
        status: 2,
        type: 2,
        source: "课程",
      }).then((res) => {
        this.categories = res.data.data;
      });
    },
    // 地址
    addMecAddr(addr) {
      if (addr.address) {
        this.$set(this.form, "province", addr.province);
        this.$set(this.form, "city", addr.city);
        this.$set(this.form, "district", addr.district);
        this.$set(this.form, "address", addr.address);
        this.cityList = [];
        this.cityList.push(addr.province);
        this.cityList.push(addr.city);
        this.cityList.push(addr.district);
      }
    },
    changeCity(v) {
      this.cityList = v;
      this.form.province = v[0];
      this.form.city = v[1];
      this.form.district = v[2];
    },
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
        this.cityList = [];
        this.cityList.push(info.province);
        this.cityList.push(info.city);
        this.cityList.push(info.district);
       this.change_categories = info.categories.split(',')
      } else {
        this.form = {};
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.aform.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.aform.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/guilds/insert";
      this.form.categories = this.change_categories.join(',')
      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.if_clear = true;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      this.form.categories = this.change_categories.join(',')
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      let url = "/user/guilds/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.if_clear = true;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    }
  },
};
</script>
  
  <style lang="scss" scoped>
</style>